import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from "axios";
import s from './TourDetails.module.scss';

const Label = ({ htmlFor, children, required }: { htmlFor: string; children: string; required?: boolean }) => (
  <label htmlFor={htmlFor} className={s.label}>
    {children}
    {required && <span className={s.required}>※</span>}
  </label>
);

const TourDetails = () => {
  const { id } = useParams();  // `id` is passed as `tour_id` in the URL
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [details, setDetails] = useState(null);
  const [options, setOptions] = useState([])
  const [otherInfo, setOtherInfo] = useState([]);
  const [qa, setQa] = useState([]);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch the tour details by tour_id (id in the URL)
    const fetchTour = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl}/api/admin/tour-details/${id}`);
        const data = response.data;
        console.log('data-options', data.options)
        console.log('data-other', data.other_info)
        console.log('data-qa', data.qa)
        console.log((Array.isArray(otherInfo)))
        setDetails(data);
        setOptions(data.options);
        setOtherInfo(JSON.parse(data.other_info));
        setQa(data.qa);
      } catch (error) {
        console.error('Error fetching tour details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTour();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setDetails((prevDetails) => ({
      ...prevDetails,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleOptionsChange = (index, field, value) => {
    const updatedOptions = [...options];
    updatedOptions[index][field] = value;
    setOptions(updatedOptions);
  };

  const handleOptionsAddRow = () => {
    setOptions((prevOptions) => {
      const optionsArray = Array.isArray(prevOptions) ? prevOptions : [];
      return [...optionsArray, { name: "", price: null, remarks: "" }];
    });
  };

  const handleOptionsDeleteRow = (index) => {
    const updatedOptions = options.filter((_, i) => i !== index);
    setOptions(updatedOptions);
  };

  const handleInfoChange = (index, field, value) => {
    const updatedInfos = [...otherInfo];
    if (updatedInfos[index]) {
      updatedInfos[index][field] = value;
      setOtherInfo(updatedInfos);
    }
  };
  const handleInfoAddRow = () => {
    setOtherInfo((prevInfo) => {
      const infoArray = Array.isArray(prevInfo) ? prevInfo : [];
      return [...infoArray, { label: "", value: "" }];
    });
  };

  const handleInfoDeleteRow = (index) => {
    const updatedInfos = otherInfo.filter((_, i) => i !== index);
    setOtherInfo(updatedInfos);
  };

  const handleQaChange = (index, field, value) => {
    const updatedQa = [...qa];
    updatedQa[index][field] = value;
    setQa(updatedQa);
  };

  const handleQaAddRow = () => {
    setQa((prevQa) => {
      const qaArray = Array.isArray(prevQa) ? prevQa : [];
      return [...qaArray, { answer: "", question: "" }];
    });
  };

  const handleQaDeleteRow = (index) => {
    const updatedQa = qa.filter((_, i) => i !== index);
    setQa(updatedQa);
  };


const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {

      const formData = new FormData();
      formData.append('duration_minutes', details.duration_minutes || '');
      formData.append('description', details.description || '');
      formData.append('warning', details.warning || '');
      formData.append('notes', details.notes || '');
      formData.append('about_price', details.about_price || '');
      formData.append('items', details.items || '');
      formData.append('is_discounted', details.is_discounted ? 1 : 0);

    if (otherInfo) {
      formData.append('other_info', JSON.stringify(otherInfo));
    }

    if (options) {
        formData.append('options', JSON.stringify(options));
    }

    if (qa) {
        formData.append('qa', JSON.stringify(qa));
    }

      const response = await axios.post(`${apiUrl}/api/admin/tour-details/update/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        maxContentLength: 50 * 1024 * 1024,
        maxBodyLength: 50 * 1024 * 1024,
      });

      if (response.status === 200) {
        console.log("ツアー更新に成功しました");
        setSuccessMessage("更新が完了しました！");
        setTimeout(() => setSuccessMessage(""), 3000);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (error) {
      console.error("ツアー更新に失敗しました", error);
      setError(error.response?.data?.message);
      if (error.response && error.response.status === 422) {
        console.log(error.response.data.errors);
      }
    } finally {
      setLoading(false);
    }
  };

  if (!details) {
    return <div>ロード中...</div>;
  }

  return (
    <div className={s.root}>
      <button onClick={() => navigate(-1)} className={s.backButton}>
        戻る
      </button>
      <button onClick={() => navigate("/")} className={s.backButton}>
        ホームに戻る
      </button>
      <button
        onClick={() => navigate(`/plans/${details.id}`)}
        className={s.planButton}
      >
        プラン編集
      </button>
      <h2>ツアー詳細を編集</h2>
      <form onSubmit={handleSubmit}>
        {error && <div className={s.error}>{error}</div>}
        {successMessage && <div className={s.success}>{successMessage}</div>}
        <div className={s.formGroupContainer}>
          <div className={s.flex}>
            <div className={s.formGroup}>
              <Label htmlFor="time" required>
                時間
              </Label>
              <input
                type="text"
                id="duration_minutes"
                name="duration_minutes"
                value={details.duration_minutes}
                onChange={handleChange}
                required
                className={s.timeInput}
              />
            </div>
            <div className={s.formGroup}>
              <Label htmlFor="is_discounted">
                複数割引
              </Label>
              <input
                type="checkbox"
                id="is_discounted"
                name="is_discounted"
                checked={details.is_discounted || false}
                onChange={handleChange}
                className={s.checkbox}
              />
            </div>
          </div>
          <div className={s.flex}>
            <div className={s.formGroup}>
              <Label htmlFor="description" required>
                説明
              </Label>
              <textarea
                id="description"
                name="description"
                value={details.description || ""}
                onChange={handleChange}
                required
              />
            </div>
            <div className={s.formGroup}>
              <Label htmlFor="warning">
                注意事項
              </Label>
              <textarea
                id="warning"
                name="warning"
                value={details.warning || ""}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className={s.flex}>
            <div className={s.formGroup}>
              <Label htmlFor="notes">
                ノート
              </Label>
              <textarea
                id="notes"
                name="notes"
                value={details.notes || ""}
                onChange={handleChange}
              />
            </div>
            <div className={s.formGroup}>
              <Label htmlFor="about_price">
                料金について
              </Label>
              <textarea
                id="about_price"
                name="about_price"
                value={details.about_price || ""}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className={s.flex}>
            <div className={s.formGroup}>
              <Label htmlFor="items">
                持ち物
              </Label>
              <textarea
                id="items"
                name="items"
                value={details.items || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className={s.optionsContainer}>
          <h2 className={s.left}>オプション</h2>
          <table className={s.table}>
            <thead>
              <tr>
                <th>名前</th>
                <th>備考</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
            {(Array.isArray(options) ? options : []).map((option, index) => (
    <tr key={index}>
      <td>
        <input
          type="text"
          value={option.name || ""}
          onChange={(e) => handleOptionsChange(index, "name", e.target.value)}
          className={s.input}
        />
      </td>
      <td>
        <input
          type="text"
          value={option.remarks || ""}
          onChange={(e) => handleOptionsChange(index, "remarks", e.target.value)}
          className={s.input}
        />
      </td>
      <td>
        <button onClick={() => handleOptionsDeleteRow(index)} type="button" className={s.deleteButton}>
          削除
        </button>
      </td>
    </tr>
  ))}
            </tbody>
          </table>
          <button onClick={handleOptionsAddRow} type="button" className={s.addButton}>
            行を追加
          </button>
        </div>
        <div className={s.optionsContainer}>
          <h2 className={s.left}>その他情報</h2>
          <table className={s.table}>
            <thead>
              <tr>
                <th>タイトル</th>
                <th>値</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
            {(Array.isArray(otherInfo) ? otherInfo : []).map((info, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="text"
                      value={info.label || ""}
                      onChange={(e) => handleInfoChange(index, "label", e.target.value)}
                      className={s.input}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={info.value || ""}
                      onChange={(e) => handleInfoChange(index, "value", e.target.value)}
                      className={s.input}
                    />
                  </td>
                  <td>
                    <button onClick={() => handleInfoDeleteRow(index)} type="button" className={s.deleteButton}>
                      削除
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={handleInfoAddRow} type="button" className={s.addButton}>
            行を追加
          </button>
        </div>
        <div className={s.optionsContainer}>
          <h2 className={s.left}>質問と回答</h2>
          <table className={s.table}>
            <thead>
              <tr>
                <th>質問</th>
                <th>回答</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
            {(Array.isArray(qa) ? qa : []).map((qaItem, index) => (
    <tr key={index}>
      <td>
        <input
          type="text"
          value={qaItem.question || ""}
          onChange={(e) => handleQaChange(index, "question", e.target.value)}
          className={s.input}
        />
      </td>
      <td>
        <input
          type="text"
          value={qaItem.answer || ""}
          onChange={(e) => handleQaChange(index, "answer", e.target.value)}
          className={s.input}
        />
      </td>
      <td>
        <button onClick={() => handleQaDeleteRow(index)} type="button" className={s.deleteButton}>
          削除
        </button>
      </td>
    </tr>
  ))}
            </tbody>
          </table>
          <button onClick={handleQaAddRow} type="button" className={s.addButton}>
            行を追加
          </button>
        </div>
        <button type="submit" className={s.saveButton} disabled={loading}>
          {loading ? "更新中..." : "更新"}
        </button>
      </form>
    </div>
  );
};

export default TourDetails;
